import React, { memo, useContext } from "react";

// Utils

import styled from "styled-components";
    

import IcCheckOff from "../../../../../resources/images/icon/checkbox/checkbox_default.svg";
import IcCheckDisable from "../../../../../resources/images/icon/checkbox/checkbox_disable.svg";
import IcCheckOn from "../../../../../resources/images/icon/checkbox/checkbox_select.svg";

import IcTrtmtGray from "../../../../../resources/images/icon/trtmtData/card/Icon_trtmt_gray.svg";
import IcTrtmtNew from "../../../../../resources/images/icon/trtmtData/card/Icon_trtmt_new.svg";


import { AppContext } from "../../../../../components/AppProvider";
import ButtonLayer from "../ButtonLayer";

export default memo((props) => {
  const { userinfo, cfg, phonecfg } = useContext(AppContext);
  const { data, setDeleteSeqNo, isCheckAll, setIsCheckAll, checkedSeqNo, setCheckedSeqNo, setLocationInfo, setDeleteData } = props;

  // const [isCheckAll, setIsCheckAll] = usetate(false);
  // const [checkedSeqNo, setCheckedSeqNo] = useState([]);

  const checkName = (checkString, maxLength, cutLengthParam) => {
    let rtnValue = checkString;
    let cutLength = 3;

    if (cutLength) {
      cutLength = cutLengthParam;
    }

    // 병원명이 5글자 이상인경우 3글자+...표시
    if (rtnValue.length >= maxLength) {
      rtnValue = rtnValue.substring(0, cutLength) + "...";
    }

    return rtnValue;
  };

  const settingSeqNo = () => {
    let checkArr = new Array();

    $("input[name=checkSeqNo]:checked").each(function () {
      checkArr.push($(this).attr("id"));
    });

    setCheckedSeqNo(checkArr);

    if (dataList.length == checkArr.length) {
      setIsCheckAll(true);
    } else {
      setIsCheckAll(false);
    }
  };

  // 전체 선택 기능 추가
  const checkedAll = () => {
    if (isCheckAll) {
      $("input:checkbox").prop("checked", false);
      settingSeqNo();
      setIsCheckAll(false);
    } else {
      $("input:checkbox").prop("checked", true);
      settingSeqNo();
      setIsCheckAll(true);
    }
  };

  const unCheckedAll = () => {
    $("input:checkbox").prop("checked", false);
    settingSeqNo();
  };

  // useEffect(() => {
  //   if (dataList.length != checkedSeqNo.length) {
  //     setIsCheckAll(false);
  //   }
  // }, [checkedSeqNo]);

  return (
    <ListItem on="false" >
      <ListItemInfoLayer on="false">
        <LineOneLayer>
          <div style={{display:"flex"}}>
            <label style={{display:'flex'}}>
              <div>
                <ItemChecked id={data.seqNo} type={"checkbox"} name={"checkSeqNoX"} onClick={settingSeqNo} disabled={true} />
              </div>
              <div style={{lineHeight:"45px"}}>
                {/* <ItemDate>{m.dataDt}</ItemDate> */}
                <ItemDate>{data.studDt}</ItemDate>
              </div>
            </label>
            <div style={{marginLeft:"auto"}}>
              <ItemHospital>{data.hsptNm}</ItemHospital>
            </div>
          </div>
          
          
        </LineOneLayer>
        <LineTwoLayer>
        <div style={{width:"26px"}}>{data.newYn == "Y" && <Img src={IcTrtmtNew} verticalAlign={"text-top"} padding={"0px"} alt="" />}</div>
          <div style={{paddingLeft:"10px"}}>
            <Img src={IcTrtmtGray} verticalAlign={"text-top"} padding={"0px"} alt="" />
          </div>
          <ContentText on="false">
            {data.studNm}
          </ContentText>
        </LineTwoLayer>
      </ListItemInfoLayer>

      <ButtonLayer btnType={"direct"} on={"false"} procType={"D"} setDeleteData={setDeleteData} data={data}/>
    </ListItem>
  );
});

/* css */

const List = styled.div`
  // padding:30px 20px;
`;

const ListHeader = styled.div`
  width: 100%;
  height: 24px;
  line-height: 24px;

  vertical-align: middle;
  margin-bottom: 10px;
`;
const ItemCheckedAll = styled.input`
  appearance: none !important;
  background: url(${IcCheckOff});
  background-color: #ffffff00 !important;
  width: 18px;
  height: 18px;
  border: 0px;

  // margin-left: 16px;
  margin-right: 10px;

  vertical-align: middle;

  box-sizing: border-box;

  :checked {
    background-image: url(${IcCheckOn});
    background-color: #fff !important;
    background-size: 100% 100%;
    background-position: 50%;
    background-repeat: no-repeat;
  }
`;

const SelectAllText = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #000000;

  display: inline-block;
  box-sizing: border-box;
  flex-direction: column;
`;

const RequestDataLayer = styled.div`
  display: inline-block;
  box-sizing: border-box;
  flex-direction: column;

  float: right;
`;

const RequestIcon = styled.div`
  display: inline-block;
  box-sizing: border-box;
  float: right;
  vertical-align: middle;
`;

const RequestImg = styled.img`
  display: inline-block;
  box-sizing: border-box;
`;

const RequestedDataText = styled.div`
  font-weight: 400;
  font-size: 14px;
  color: #999999;

  display: inline-block;
  box-sizing: border-box;
  float: right;
  vertical-align: middle;
`;

const ListItem = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  // gap: 85px;

  position: relative;
  width: 100%;
  height: 120px;
  margin: 0 0 12px 0; // 위, 오른쪽, 아래, 왼쪽

  background: #ffffff;
  border: 1px solid ${(props) => (props.on === "true" ? "#6A62E6" : "#D9D9D9")};
  border-radius: 8px;
  border-bottom-width: medium;
`;

const ListItemInfoLayer = styled.div`
  width: 100%;
  height: 80px;
  display: inline-block;
  flex-direction: row;
  // border: 1px solid #FF0000;

  // border-bottom:1px solid #6A62E6;
  border-bottom: 1px solid
    ${(props) => (props.on === "true" ? "#6A62E6" : "#D9D9D9")};
`;

const LineOneLayer = styled.div`
  width: 100%;
  height: 42px;
  line-height: 42px;
`;

const ItemChecked = styled.input`
  appearance: none !important;
  background: url(${(props) => props.disabled ? IcCheckDisable : IcCheckOff});
  background-color: #fff !important;
  width: 18px;
  height: 18px;

  margin-left: 16px;
  margin-right: 10px;

  vertical-align: middle;

  box-sizing: border-box;

  :checked {
    background-image: url(${IcCheckOn});
    background-color: #fff !important;
    background-size: 100% 100%;
    background-position: 50%;
    background-repeat: no-repeat;
  }
`;

const ItemDate = styled.div`
  color: #000000;

  display: inline-block;
  text-align: center;
  box-sizing: border-box;
`;

const ItemHospital = styled.div`
  // font-family: 'Pretendard';
  // font-style: normal;
  // font-weight: 400;
  // font-size: 14px;

  max-width: 127px;

  margin-right: 12px;
  color: #000000;

  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;

  display: inline-block;
  box-sizing: border-box;
  float: right;
  line-height: 45px !important;
`;

const Img = styled.img`
  vertical-align:middle;
  // padding-bottom: 3px;
`;

const ImgPen = styled.img`
  // vertical-align:middle;

  // display: inline-block;
  // box-sizing: border-box;
  // float: right;
  vertical-align: ${(props) =>
    props.verticalAlign ? props.verticalAlign : "middle"};
  padding: ${(props) => (props.padding ? props.padding : "2px 0px")};
  width: 11.37px;
  height: 11.39px;
`;

// const ItemMap = styled.div`
//   margin-right: 8px;

//   display: inline-block;
//   box-sizing: border-box;
//   float: right;
// `;

const ItemMap = styled.div`
    margin-right: 20px;

    display: inline-block;
    box-sizing: border-box;
    float: right;
`

const LineTwoLayer = styled.div`
  // height: 46px;
  display: flex;
  box-sizing: border-box;

  height: 22px;
  // line-height: 22px;
  line-height: 20px;
  margin: 0 19px 0 17px;

  vertical-align: middle;
`;

const ContentText = styled.div`
  max-width: 69%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;

  margin-left: 10px;
  margin-right: 10px;

  display: inline-block;
  box-sizing: border-box;
  vertical-align: middle;

  color: ${(props) => (props.on === "true" ? "#6A62E6" : "#A2A2A2")};
`;

const ListButtonLayer = styled.div`
  text-align: center;
  width: 100%;
  height: 38px;
  line-height: 38px;
`;

const LeftButton = styled.div`
  width: 50%;

  display: inline-block;
  text-align: center;

  font-family: "Pretendard";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;

  color: #6a62e6;
  box-sizing: border-box;
`;

const RightButton = styled.div`
  width: 50%;

  display: inline-block;
  text-align: center;

  font-family: "Pretendard";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;

  color: #6a62e6;
  box-sizing: border-box;

  // border-left:1px solid #6A62E6;
  border-left: 1px solid
    ${(props) => (props.on === "true" ? "#6A62E6" : "#D9D9D9")};
`;

const ButtonText = styled.div`
  text-align: center;
  display: inline-block;
  box-sizing: border-box;

  margin-left: 4px;

  font-family: "Pretendard";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;

  color: ${(props) => (props.on === "true" ? "#6A62E6" : "#A2A2A2")};
`;

const ImgInText = styled.p`
  display: inline-block;
  position: absolute;
  left: 8.5rem;
  color: #fff;
`;

const ImgCnt = styled.div`
  position: absolute;
  display: inline-block;
  height: 20px;
  line-height: 20px;
  padding: 0px 5px;
  font-size: 10px;
  color: #fff;
  border-radius: 4px;
  background: #6a62e6;
`;

const ImgCntI = styled.i`
  display: inline-block;
  vertical-align: middle;
  width: 12px;
  height: 12px;
  background: url(${(props) => props.src}) no-repeat center;
  background-size: contain;
  margin: 0 4px 2px 0;
`;

const CheckLabel = styled.label`
  background: url(${IcCheckOff});
  width: 18px;
  height: 18px;

  margin-left: 16px;
  margin-right: 10px;

  vertical-align: middle;

  display: inline-block;
  box-sizing: border-box;

  &:checked {
    background: url(${IcCheckOn});
  }
`;
